import { render, staticRenderFns } from "./AuxiliaryStatistics.vue?vue&type=template&id=164e0201&scoped=true&"
import script from "./AuxiliaryStatistics.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryStatistics.vue?vue&type=style&index=0&id=164e0201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e0201",
  null
  
)

export default component.exports